import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phoneNumberPattern = /^\+\d{1,3} \(\d{3}\) \d{3} \d{4}$/;
    const valid = phoneNumberPattern.test(control.value);
    return valid ? null : { phoneNumberInvalid: true };
  };
}
